import React, { Component } from "react";
import { NotesComponent } from "./NotesComponent";
import {
  Button,
  Col,
  Dropdown,
  Form,
  Icon,
  Input,
  Menu,
  Row,
  Spin
} from "antd";
import { urlPath } from "./Settings";
import { getAuthHeader } from "../utils/security";

const spinStyle = {
  margin: "50px",
  display: "block"
};
const { TextArea } = Input;

class Notes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notes: [],
      loading: false,
      publicAccess: false,
      noteValue: ""
    };
  }
  componentDidMount() {
    this.getNotes();
  }

  getNotes = () => {
    this.setState({ loading: true });
    fetch(
      urlPath +
        "/api/loadnotes?matspec=" +
        this.props.specId +
        "&timezone=" +
        Intl.DateTimeFormat().resolvedOptions().timeZone,
      {
        credentials: "include",
        headers: getAuthHeader()
      }
    )
      .then(response => response.json())
      .then(data => {
        console.log("Notes loaded", data);
        this.setState({ notes: data, loading: false });
      })
      .catch(e => {
        console.error("Cannot load notes!", e);
        this.setState({ loading: false });
      });
  };

  submitNote = e => {
    this.setState({ noteValue: "" });
    const access = this.props.internal ? this.state.publicAccess : true;
    if (this.state.noteValue) {
      fetch(
        urlPath +
          "/api/notesave" +
          "?matspec=" +
          this.props.specId +
          "&text=" +
          encodeURIComponent(this.state.noteValue).replace("%250A", "%0A") +
          "&access=" +
          access,
        { method: "POST", credentials: "include", headers: getAuthHeader() }
      )
        .then(response => response.json())
        .then(data => {
          console.log("Note save", data);
          this.getNotes();
        })
        .catch(e => console.error("Cannot save note!", e));
      this.props.noteSaved();
    } else {
      console.error("Cannot save an empty note");
    }
  };
  onChange = e => {
    const noteValue = e.target.value;
    console.log(noteValue);
    this.setState({
      noteValue
    });
  };
  onAccessChange = e => {
    const key = e.key;
    let publicAccess = null;
    if (key === "public") {
      publicAccess = true;
    } else {
      publicAccess = false;
    }
    console.log(publicAccess);
    this.setState({ publicAccess });
  };
  render() {
    const { notes, loading, noteValue } = this.state;
    const { translations } = this.props;
    const menu = (
      <Menu onClick={this.onAccessChange}>
        <Menu.Item key="public">
          <Icon type="user" />
          {translations.public}
        </Menu.Item>
        <Menu.Item key="internal">
          <Icon type="user" />
          {translations.internal}
        </Menu.Item>
      </Menu>
    );
    //if (notes && notes.length > 0)
    if (loading) return <Spin style={spinStyle} />;
    return (
      <div className="notes-container">
        <Form>
          <Row>
            <Col span={24}>
              <Form.Item style={{ margin: 0 }}>
                <TextArea
                  value={noteValue}
                  placeholder={translations.enterNote}
                  onChange={this.onChange}
                />
              </Form.Item>
            </Col>
            <Col span={24} style={{ margin: "5px 0", textAlign: "right" }}>
              <Form.Item>
                <Button
                  onClick={this.submitNote}
                  type="primary"
                  htmlType="submit"
                >
                  {translations.submit}
                </Button>
                {this.props.internal && (
                  <Dropdown overlay={menu}>
                    <Button style={{ marginLeft: "10px" }}>
                      {this.state.publicAccess
                        ? translations.public
                        : translations.internal}
                      <Icon type="down" />
                    </Button>
                  </Dropdown>
                )}
              </Form.Item>
            </Col>
          </Row>
        </Form>
        {notes &&
          notes.map((note, index) => (
            <NotesComponent
              key={index}
              text={note.text}
              id={note.id}
              creatorId={note.creatorid}
              creatorName={note.creator.name}
              time={note.time}
              access={note.access}
            />
          ))}
      </div>
    );
    //return <p>No Notes to display</p>;
  }
}

export default Notes;



// WEBPACK FOOTER //
// ./src/components/Notes.js